import axios from 'axios';
import { CC_API_BASE_URL, getCcRequestConfig } from '../config/ccApiConfig';

const specialApplicationService = {
    getSpecialApplication: () => {
      return axios.get(
        `${CC_API_BASE_URL}/SpecialApplication`,
        getCcRequestConfig()
      );
    }
};
export default specialApplicationService;